export default {
  methods: {
    isEmail(arg) {
      const regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (!regex.test(arg)) return 'Informe um email válido.';
      return '';
    },
    isBlank(arg) {
      const message = 'Este campo é obrigatório!';
      if (_.isUndefined(arg)) return message;
      if (arg.length <= 0) return message;
      return '';
    },
    isMinorThan(arg, min) {
      if (!_.isUndefined(min) && arg.length < min) return `Este campo precisa ter no mínimo ${min} dígitos!`;
      return '';
    },
  },
};
